export const WORKFLOW_RUN_STATUS = Object.freeze({
  SCHEDULED: 1,
  STARTED: 2,
  AWAITED: 3,
  SUCCEEDED: 4,
  FAILED: 5,
  CANCELLED: 6,
  ALERTED: 7,
} as const);

export const WORKFLOW_RUN_CATEGORY = Object.freeze({
  ALL: 'all',
  ONE_WEEK: 'within-one-week',
  ONE_MONTH: 'within-one-month',
  UNSUCCESSFUL: 'unsuccessful',
  CUSTOM: 'custom-period',
} as const);

export type WorkflowRunStatusKey = keyof typeof WORKFLOW_RUN_STATUS;
export type WorkflowRunStatusValue = (typeof WORKFLOW_RUN_STATUS)[WorkflowRunStatusKey];

export type WorkflowRunCategoryKey = keyof typeof WORKFLOW_RUN_CATEGORY;
export type WorkflowRunCategoryValue = (typeof WORKFLOW_RUN_CATEGORY)[WorkflowRunCategoryKey];
